import { Alert, Badge, Loader, Paper, Stack, Table, Text, Title } from "@mantine/core";
import { useEffect, useState } from "react";

import { ApiError, api, type HealthOverview } from "../lib/api";

export function HealthPanel() {
  const [health, setHealth] = useState<HealthOverview | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let alive = true;
    const tick = () => {
      api
        .health()
        .then((h) => {
          if (alive) setHealth(h);
        })
        .catch((err) => {
          if (alive) setError(err instanceof ApiError ? err.detail : "fetch failed");
        });
    };
    tick();
    const i = window.setInterval(tick, 5000);
    return () => {
      alive = false;
      window.clearInterval(i);
    };
  }, []);

  if (error) return <Alert color="red">{error}</Alert>;
  if (health === null) return <Loader size="sm" />;

  return (
    <Stack>
      <Title order={2}>Cluster health</Title>
      <Text c="dimmed">Live status, polled every 5 seconds.</Text>
      <Paper withBorder>
        <Table>
          <Table.Thead>
            <Table.Tr>
              <Table.Th>Component</Table.Th>
              <Table.Th>Status</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            <Row name="API process" ok={health.api} />
            <Row name="Oracle ADB" ok={health.oracle} />
            <Row name="Object storage (OCI)" ok={health.object_storage} />
          </Table.Tbody>
        </Table>
      </Paper>
    </Stack>
  );
}

function Row({ name, ok }: { name: string; ok: boolean }) {
  return (
    <Table.Tr>
      <Table.Td>{name}</Table.Td>
      <Table.Td>
        <Badge color={ok ? "green" : "red"} variant="light">
          {ok ? "OK" : "DOWN"}
        </Badge>
      </Table.Td>
    </Table.Tr>
  );
}
